import React, { useState, useRef, useEffect } from "react";
import {
  Menu,
  Bell,
  ShieldCheck,
  UserCircle,
  LogOut,
  ChevronDown,
} from "lucide-react";
import { useNavigate } from "react-router-dom";


const Header = ({ toggleSidebar }) => {
  const [openProfile, setOpenProfile] = useState(false);
  const navigate = useNavigate();
  const profileRef = useRef(null);
  const [user, setUser] = useState(null);

const handleLogout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  navigate("/", { replace: true });
};


  useEffect(() => {
  const userData = localStorage.getItem("user");

  if (userData) {
    setUser(JSON.parse(userData));
  }
}, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileRef.current &&
        !profileRef.current.contains(event.target)
      ) {
        setOpenProfile(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };
  }, []);

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-slate-200 shadow-sm">
      <div className="h-20 px-4 md:px-8 flex items-center justify-between">

        {/* Left */}
        <div className="flex items-center gap-4">
          <button
            onClick={toggleSidebar}
            className="md:hidden p-2 rounded-xl hover:bg-slate-100"
          >
            <Menu size={22} />
          </button>

          <div>
            <h1 className="text-xl md:text-2xl font-bold text-slate-800">
              Backup Dashboard
            </h1>

            <p className="text-sm text-slate-500">
              Secure Offline Data Management
            </p>
          </div>
        </div>

        {/* Right */}
        <div className="flex items-center gap-4">

          {/* Backup Status */}
          <div className="hidden md:flex items-center gap-2 bg-green-50 border border-green-100 px-4 py-2 rounded-xl">
            <ShieldCheck
              size={18}
              className="text-green-600"
            />

            <span className="text-sm font-medium text-green-700">
              Backup Active
            </span>
          </div>

          {/* Notification */}
          <button className="relative p-3 rounded-xl hover:bg-slate-100 transition">
            <Bell size={22} />

            <span className="absolute top-2 right-2 h-2.5 w-2.5 bg-red-500 rounded-full"></span>
          </button>

          {/* User Profile */}
          <div
            className="relative"
            ref={profileRef}
          >
            <button
              onClick={() =>
                setOpenProfile(!openProfile)
              }
              className="flex items-center gap-3 bg-slate-50 border border-slate-200 px-3 py-2 rounded-xl hover:bg-slate-100 transition"
            >
              <UserCircle
                size={38}
                className="text-slate-700"
              />

              <div className="hidden md:block text-left">
               <h4 className="text-sm font-semibold text-slate-800">
  {user?.userName || "Guest User"}
</h4>

<p className="text-xs text-slate-500">
  {user?.mobileNo || ""}
</p>
              </div>

              <ChevronDown
                size={16}
                className={`transition-transform ${
                  openProfile ? "rotate-180" : ""
                }`}
              />
            </button>

            {/* Dropdown */}
            {openProfile && (
              <div className="absolute right-0 mt-3 w-60 bg-white border border-slate-200 rounded-2xl shadow-xl overflow-hidden z-50">

                <div className="p-4 bg-slate-50 border-b">
                <h4 className="font-semibold text-slate-800">
  {user?.userName || "Guest User"}
</h4>

<p className="text-sm text-slate-500">
  {user?.mobileNo || ""}
</p>
                </div>

                <button
                  onClick={handleLogout}
                  className="w-full flex items-center gap-3 px-4 py-3 text-red-600 hover:bg-red-50 transition"
                >
                  <LogOut size={18} />
                  Logout
                </button>

              </div>
            )}
          </div>

        </div>

      </div>
    </header>
  );
};

export default Header;